import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { isAgentWorkspacePath } from "../util/routeAccess";


const WithHeaderLayout = () => {
  const location = useLocation();
  const showFooter = ["/privacy", "/terms", "/data-deletion"].includes(location.pathname);
  return (
    <div>
      {!isAgentWorkspacePath(location.pathname) && <Header />}
      <Outlet />
      {showFooter && <Footer />}
    </div>
  );
};

export default WithHeaderLayout;
